<template>
  <div id="app">
    <main>
      <router-view></router-view>
    </main>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb.vue'
import TopBar from '@/components/TopBar.vue'
import SideBar from '@/components/SideBar.vue'
import { mapState } from 'vuex'

export default {
  name: 'app',
  components: {
    Breadcrumb,
    TopBar,
    SideBar
  },
  computed: mapState(['currentUser'])
}
</script>

<style lang="scss">
@import 'node_modules/materialize-css/sass/materialize';
.open-side-bar {
  header, main, footer {
    padding-left: 300px;
  }
  .navbar-fixed nav.navbar {
    width: calc(100% - 300px);
    left: 300px;
    padding: 0 20px;
  }
}
.collapsible li > a,
.collapsible li > .collapsible-header {
  padding: 0 16px;
  line-height: 64px;
  height: 64px;
}
.collapsible li > a > i,
.collapsible li > .collapsible-header > i {
  line-height: 64px !important;
}
.sidenav li > a > .fas {
    font-size: 1.4rem;
}
.sidenav .user-view {
  margin: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.sidenav .user-view > a {
  display: flex;
  justify-content: center;
}

@media only screen and (max-width : 992px) {
  header, main, footer {
    padding-left: 0;
  }
  .navbar-fixed nav.navbar {
    width: 100%;
    left: auto;
    padding: 0 20px;
  }
}

body {
  background-color: #F5F5F5;
}
.headband {
  padding: 2px 0;
  background-color: #ffffff;
  img {
    max-height: 44px;
  }
  .row {
    margin-bottom: 0;
  }
}


.input-field input[type=text].invalid,
.input-field input[type=password].invalid,
.input-field input[type=email].invalid
{
  box-shadow: 0 1px 0 0 red;
  color: red;
}
.input-field input[type=text].invalid + label,
.input-field input[type=password].invalid + label,
.input-field input[type=email].invalid + label
{
  color: red;
}
.helper-text {
  font-size: 11px;
  padding-left: 10px;
}
.helper-text-error {
  color: red !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue